<template>
  <div
    class="toolbar d-flex flex-wrap justify-content-between align-items-center app--mobile-hidden"
    :disabled="loading"
    :style="{ padding: padding }"
  >
    <div class="d-flex align-items-center">
      <slot></slot>
      <!-- hide this button when exporting pdf when data-html2canvas-ignore is set-->
      <b-button
        class="reset-button"
        variant="outline-secondary"
        @click="$emit('reset')"
        v-if="isShowReset"
        data-html2canvas-ignore
      >
        重設
      </b-button>
    </div>
    <div class="d-flex flex-warp">
      <slot name="end"></slot>
    </div>
    <BaseActionModal id="mobile-filter-toolbar" :showFooter="false">
      <template v-slot:modalHeader>
        <div class="d-flex justify-content-between" style="width: 100%;">
          <button
            type="button"
            aria-label="Close"
            class="close"
            @click="$bvModal.hide('mobile-filter-toolbar')"
          >
            ×
          </button>
          <h5>搜尋</h5>
          <ButtonReset @click="$emit('reset')" v-if="isShowReset"></ButtonReset>
        </div>
      </template>
      <div class="d-flex flex-column">
        <slot></slot>
        <slot name="end"></slot>
        <div class="d-flex justify-content-center">
          <b-button variant="primary" @click="$bvModal.hide('mobile-filter-toolbar')">
            搜尋
          </b-button>
        </div>
      </div>
    </BaseActionModal>
    <BaseActionModal id="mobile-update-coupon" isMobileUpdateCoupon :showFooter="false">
      <template v-slot:modalHeader>
        <div class="d-flex justify-content-center" style="width: 100%;">
          <h5>更新優惠券</h5>
        </div>
      </template>
      <slot name="mobile-update"></slot>
    </BaseActionModal>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue';
import { ButtonReset } from '@/components/button';
import BaseActionModal from '@/components/BaseActionModal.vue';

export default {
  name: 'BaseFilterToolbar',
  props: {
    loading: Boolean,
    tags: Array,
    isShowReset: {
      default: true,
      type: Boolean,
    },
    padding: {
      default: '20px',
      type: String,
    },
  },
  components: {
    BButton,
    BaseActionModal,
    ButtonReset,
  },
};
</script>

<style lang="scss" scoped>
.toolbar {
  button {
    margin: 0;

    &.reset-button {
      height: 47px;
      color: #495057 !important;
    }
    &.btn-outline-secondary {
      border-color: #ced4da !important;
    }

    &.reset-button {
      vertical-align: inherit;
      height: 40px;
    }
  }

  ::v-deep {
    label {
      margin: 0;
    }
  }
}

::v-deep {
  .custom-select {
    vertical-align: initial;
  }

  .keyword-select {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    width: unset;
  }

  .form-control {
    height: initial;
  }

  #keyword-filter {
    position: relative;
    width: 100%;

    input {
      padding-left: 30px;
    }
    &:before {
      content: "";
      position: absolute;
      width: 24px;
      height: 24px;
      top: 25%;
      margin: 0 6px;

      background: url(../assets/img/search.svg) no-repeat center center;
    }
  }

  label + #keyword-filter {
    input {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
}

#mobile-filter-toolbar {
  button {
    &.mobile-button {
      &__reset {
        background: none;
        color: #dcdcdc;
        border: none;
        border-bottom: 1px solid #dcdcdc;

        &:focus {
          outline: none;
        }
      }
    }
  }
}
</style>
